import { DatePipe } from '@angular/common';
import { Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: any, pattern: string = 'mediumDate'): any {
    if (!value) return null;
    const datePipe: DatePipe = new DatePipe(this.translateService.currentLang ?? 'es');
    const formatted = datePipe.transform(value, pattern);
    if (!formatted) return formatted;
    return this.adjustDateCasing(formatted, pattern);
  }

  /**
   * Catalan (and similar) locales include the preposition in the month token
   * ("d'agost", "de novembre"). Keep "de"/"d'" lowercase and capitalize the month.
   * Full weekday names are capitalized without turning "d'Agost" into "D'agost".
   */
  private adjustDateCasing(formatted: string, pattern: string): string {
    let result = formatted.replace(
      /(^|[^A-Za-zÀ-ÿ])de\s+([A-Za-zÀ-ÿ])/gi,
      (_match, prefix: string, monthInitial: string) => `${prefix}de ${monthInitial.toUpperCase()}`
    );
    result = result.replace(
      /(^|[^A-Za-zÀ-ÿ])d['’]([A-Za-zÀ-ÿ])/gi,
      (_match, prefix: string, monthInitial: string) => `${prefix}d'${monthInitial.toUpperCase()}`
    );

    if (/E{4}|c{4}/.test(pattern) && !/^(de |d['’])/i.test(result)) {
      result = result.replace(/^[a-zàáèéíïòóúüçñ]/, (char) => char.toUpperCase());
    }

    return result;
  }
}
